import React, { memo } from 'react'
import logo from '../../assets/img/logo.png';
import styles from './footer.module.css'

const url = 'https://t.me/partiturabot';

export const Footer = memo(() => <footer className={styles.footer}>
  <div className={styles.inner}>
    <div className={styles.brand}>
      <img src={logo} alt='' className={styles.logo} />
      <div>
        <p className={styles.name}>Partitura BOT</p>
        <p className={styles.tagline}>Seu buscador de partituras no Telegram.</p>
      </div>
    </div>

    <nav className={styles.links} aria-label='Links do rodapé'>
      <a
        className={styles.link}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        Pesquise no Telegram
      </a>
      <a
        className={styles.link}
        href={`${url}?text=%2Fcontribuir`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Ganhe acesso VIP
      </a>
    </nav>
  </div>
  <div className={styles.bottom}>
    © {new Date().getFullYear()} Partitura BOT
  </div>
</footer>)

export default Footer;
